import { forceSimulation, forceLink, forceManyBody, forceCenter, forceCollide } from "d3-force";

export function layoutNodes(nodes, links) {
  const sim = nodes.map((n, i) => ({ id: n.id, x: n.pos?.[0] ?? Math.cos(i) * 300, y: n.pos?.[1] ?? Math.sin(i) * 300, fx: n.pos?.[0], fy: n.pos?.[1] }));
  if (sim.some((n) => n.fx == null)) {
    const ids = new Set(sim.map((n) => n.id));
    forceSimulation(sim)
      .force("link", forceLink(links.filter((l) => ids.has(l.a) && ids.has(l.b)).map((l) => ({ source: l.a, target: l.b }))).id((d) => d.id).distance(220))
      .force("charge", forceManyBody().strength(-700))
      .force("center", forceCenter(0, 0))
      .force("collide", forceCollide(80))
      .stop()
      .tick(300);
  }
  return Object.fromEntries(sim.map((n) => [n.id, { x: n.x, y: n.y }]));
}

export const typeMap = (types) => Object.fromEntries(types.map((t) => [t.key, t]));
export const pairKey = (a, b) => [a, b].sort().join("|");
